import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';

@Component({
  selector: 'delete-tenant-dialog',
  templateUrl: './delete-tenant-dialog.component.html',
  styleUrls: ['./delete-tenant-dialog.component.scss']
})
export class DeleteTenantDialogComponent implements OnInit {

  deleteTenantForm!:FormGroup;
  tenantDto!:TenantDto;

  _db!:string;

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<DeleteTenantDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private tenantService: TenantService,
    private oauthService: OAuthServiceService) { }

  ngOnInit(): void {
    console.log(this.data)
    this.tenantDto = this.data;
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin'){
              this._db = dbrole;
            }
          });
        }
      }
    });
    this.createDeleteTenantForm();
  }

  createDeleteTenantForm(){
    this.deleteTenantForm = this.fb.group({
      id:[this.tenantDto.id],
      name:[this.tenantDto.name]
    })
  }

  deleteTenant(id:string) {
    if(this.deleteTenantForm.valid) {
      if(this._db){
        this.tenantService.deleteTenancy(id).subscribe({
          next:(data) => {
            this.dialogRef.close();
          }
        });
      }     
    }
  }
  cancel(){
    this.dialogRef.close();
  }

}
